import { render, staticRenderFns } from "./orderUpdateDetail.vue?vue&type=template&id=4bf2bba7&scoped=true&"
import script from "./orderUpdateDetail.vue?vue&type=script&lang=js&"
export * from "./orderUpdateDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderUpdateDetail.vue?vue&type=style&index=0&id=4bf2bba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2bba7",
  null
  
)

export default component.exports